import React from 'react';

const WhyGloboflo = () => {
  return (
    <section className="why">
      <div className="container">
        <p className="why-eyebrow">Why Globoflo?</p>
        <h2 className="why-title">We've built infrastructure, technology, and expertise that transforms returns management and overstock from cost centers into value generators.</h2>
      </div>
    </section>
  );
};

export default WhyGloboflo;

